import React from 'react';
import { ProductSetAccommodation, SelectedAccommodation } from 'services/BackendApi';
import { formatDateDisplay } from 'utils/date';
import { countNightsBetween, addDays as addDaysUtc } from 'utils/date.utc';
import { pluralize } from 'utils/string';

interface IAccommodationDatesGuestsProps {
  requestedAccommodation: SelectedAccommodation;
  offers: string[];
  accommodation: ProductSetAccommodation;
}

export const AccommodationDatesGuests: React.FC<IAccommodationDatesGuestsProps> = ({
  requestedAccommodation,
  offers,
  accommodation,
}) => {
  return (
    <div className="accommodation-data-left">
      <div className="dates-line flex justify-start mt-5px">
        <p className="booking-dates-container booking-adults font-hurmegeometric-sans text-13px leading-16px text-flint uppercase m-0 flex gap-1 lg:items-center flex-col lg:flex-row">
          <span className="booking-dates font-bold">
            {formatDateDisplay(requestedAccommodation.startDate)} -{' '}
            {formatDateDisplay(addDaysUtc(requestedAccommodation.endDate, 1))}
          </span>
          <span className="inline-block lg:inline booking-nights bg-teal-20 ml-0 lg:ml-5px p-2px">
            {countNightsBetween(
              requestedAccommodation.startDate,
              addDaysUtc(requestedAccommodation.endDate, 1)
            )}{' '}
            {pluralize(
              countNightsBetween(
                requestedAccommodation.startDate,
                addDaysUtc(requestedAccommodation.endDate, 1)
              ),
              'NIGHT'
            )}
          </span>
          <span>
            {requestedAccommodation.guestAges?.numberOfAdults} x{' '}
            {requestedAccommodation.guestAges?.numberOfAdults === 1 ? 'ADULT' : 'ADULTS'}
          </span>
        </p>
        {requestedAccommodation.guestAges?.agesOfAllChildren?.length ? (
          <p className="booking-children font-hurmegeometric-sans text-13px leading-16px text-flint uppercase ml-5 m-0">
            {requestedAccommodation.guestAges.agesOfAllChildren?.length} x{' '}
            {requestedAccommodation.guestAges.agesOfAllChildren?.length === 1 ? 'CHILD' : 'CHILDREN'}
          </p>
        ) : null}
        {requestedAccommodation.guestAges.agesOfAllChildren?.length >= 1 && (
          <span className="font-hurmegeometric-sans text-13px leading-16px text-flint uppercase ml-2 m-0">
            ({requestedAccommodation.guestAges.agesOfAllChildren.map(ageNum => `${ageNum}`).join(', ')} YO)
          </span>
        )}
      </div>
      {offers.map((offer, offerIndex) => (
        <div
          key={`offer-${accommodation.products[0].uuid}${offerIndex}`}
          className="offer-item font-hurmegeometric-sans text-13px leading-16px text-red-92 uppercase mt-[5px] mr-[30px]"
        >
          {offer}
        </div>
      ))}
    </div>
  );
};
